<template>
    <youtube :video-id="videoId" :player-vars="playerVars"></youtube>
</template>

<script>
    export default {
        props: {
            type: {
                default: 'youtube'
            },
            url: {
                required: true
            },
            playerVars: {
                default: () => {
                    return {
                        rel: 0
                    }
                }
            },
        },

        data() {
            return {
                videoId: this.$youtube.getIdFromUrl(this.url)
            }
        },

        mounted() {
            console.log('Vieo Preview Component Mounted.');
        }
    }
</script>
